import { ReduxStore } from "../reducers/root_reducer";

const getTosAcceptances = (state: ReduxStore, props) => state?.tos?.acceptances;

export default getTosAcceptances;
